import axios from "axios";
import { API_URL } from "config";
import {
  getCurrentAppPath,
  getLoginPath,
  savePostLoginRedirect,
} from "./authRedirect";

const axiosServices = axios.create({
  baseURL: API_URL || "http://localhost:8010/",
});

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem("serviceToken");
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosServices.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refreshToken");

      if (refreshToken) {
        try {
          const response = await axiosServices.post("/api/auth/refresh-token", {
            refreshToken,
          });
          const newAccessToken = response.data.accessToken;
          const newRefreshToken = response.data.refreshToken;

          localStorage.setItem("serviceToken", newAccessToken);
          if (newRefreshToken) {
            localStorage.setItem("refreshToken", newRefreshToken);
          }

          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axiosServices(originalRequest);
        } catch (refreshError) {
          savePostLoginRedirect(getCurrentAppPath());
          window.location = getLoginPath();
          return Promise.reject(refreshError);
        }
      }
    }

    if (
      error.response?.status === 401 &&
      !window.location.href.includes("/login")
    ) {
      const isPublicRoute =
        window.location.href.includes("/reset-password") ||
        window.location.href.includes("/forgot-password") ||
        window.location.href.includes("/check-mail") ||
        window.location.href.includes("/primeiro-acesso");

      if (!isPublicRoute) {
        savePostLoginRedirect(getCurrentAppPath());
        window.location = getLoginPath();
      }
    }

    if (error.response?.status === 413) {
      return Promise.reject({
        message: "O arquivo enviado ultrapassa o tamanho máximo permitido pelo servidor.",
        statusCode: 413,
      });
    }

    return Promise.reject(
      (error.response && error.response.data) || "Wrong Services",
    );
  },
);

export default axiosServices;

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.post(url, { ...config });

  return res.data;
};
